import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog, DialogActions, DialogTitle, Button, Typography, Container, Box
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { HBox, VBox } from '../../../assets/SharedComponents';

const useStyles = makeStyles(() => ({
    dialog: {
        borderRadius: '25px !important',
        alignItems: 'center !important',
        justifyContent: 'space-around !important',
    },
    button: {
        alignItems: 'center !important',
        justifyContent: 'center !important',
        marginBottom: '1.1rem !important',
        borderRadius: '50px !important',
        width: '14rem !important',
        color: '#fff !important',
        fontSize: '1rem !important',
        textTransform: 'capitalize !important',
        backgroundColor: '#3a7735 !important',
        '&:hover': { background: '#2d5e29 !important' },
    },
    outlineButton: {
        alignItems: 'center !important',
        justifyContent: 'center !important',
        backgroundColor: '#ffffff !important',
        marginBottom: '1.1rem !important',
        border: '1px solid #3a7735 !important',
        borderRadius: '50px !important',
        width: '14rem !important',
        color: '#3a7735 !important',
        fontSize: '1rem !important',
        textTransform: 'capitalize !important',
        '&:hover': { backgroundColor: '#e8f5e9 !important' },
    },
}));

const CouponTypeSelector = ({ open, onClose, onTypeSelected }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const handleSelectType = (type) => {
        onTypeSelected(type);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: { xs: '20rem', md: '32rem' },
                    borderRadius: '25px !important',
                    maxWidth: 'max-content',
                    backgroundColor: '#f0f3f0',
                }
            }}>
            <Container>
                <DialogTitle>
                    <HBox className={classes.dialog}>
                        <DialogActions>
                            <Button onClick={onClose} sx={{ marginLeft: { xs: '10rem', md: '22rem' } }}>
                                <CloseOutlinedIcon />
                            </Button>
                        </DialogActions>
                    </HBox>
                </DialogTitle>

                <VBox alignItems="center" sx={{ pb: '1.5rem', px: '1rem', gap: '1rem' }}>
                    <LocalOfferOutlinedIcon sx={{ color: '#3a7735', fontSize: '2.5rem' }} />
                    <Typography sx={{ color: '#3a7735', fontWeight: 'bold', fontSize: '1.2rem', textAlign: 'center' }}>
                        {t('couponTypeTitle', 'בחר סוג קופון')}
                    </Typography>
                    <Typography sx={{ color: '#555', textAlign: 'center', fontSize: '0.9rem' }}>
                        {t('couponTypeSubtitle', 'בחר את סוג הקופון שברשותך')}
                    </Typography>

                    <VBox alignItems="center" gap="0.75rem" sx={{ width: '100%' }}>
                        {/* TODO: Add Hever coupon type when service is ready */}
                        {/* <Button
                            className={classes.button}
                            onClick={() => handleSelectType('hever')}
                            fullWidth
                        >
                            {t('couponTypeHever', 'קופון Hever')}
                        </Button> */}
                        <Button
                            className={classes.button}
                            onClick={() => handleSelectType('ramatgan')}
                            fullWidth
                        >
                            {t('couponTypeRamatGan', 'קופון רמת גן')}
                        </Button>
                    </VBox>

                    <DialogActions sx={{ flexDirection: 'column', gap: '0.5rem', alignItems: 'center', width: '100%' }}>
                        <Button className={classes.outlineButton} onClick={onClose} fullWidth>
                            {t('cancel', 'ביטול')}
                        </Button>
                    </DialogActions>
                </VBox>
            </Container>
        </Dialog>
    );
};

export default CouponTypeSelector;
